import $ from 'jquery';

export default function injectExpandCanvasHtml() {
  $('#expand-canvas-container').html(
    '<canvas id="drawing-expand-canvas"></canvas>'
  );
}
